<template>
  <div class="home-game-box">
    <div class="type-box">
      <ul>
        <li
          v-for="(item, index) in tabs"
          :key="index"
          @click="tabClick(item, index)"
        >
          <div
            :class="usrIndex == index ? 'selected' : 'icon'"
            :style="
              usrIndex == index
                ? 'border: 2px solid #d69346 !important;background:linear-gradient(90deg, #e3aa34, #ffffe0) !important;'
                : 'border: 1px solid #483f37;'
            "
          >
            <img v-if="item.id != -1" :src="item.game_img" />
            <img v-else :src="safeWapConfig.recommend_img" />
          </div>
          <p>{{ item.name }}</p>
        </li>
      </ul>
    </div>
    <div class="game-box">
      <div class="game-box-search">
        <div><van-search v-model="key" placeholder="请输入搜索字..." /></div>
      </div>
      <div v-show="usrIndex == 0">
        <div
          class="game-item"
          v-for="(item, index) in hotGame.filter(
            x =>
              x.platform_name.toLowerCase().indexOf(key) != -1 ||
              x.name.toLowerCase().indexOf(key) != -1
          )"
          :key="index"
          @click="toGame(item)"
        >
          <img :src="item.mobile_img" />
          <div class="name">
            <a class="van-ellipsis">{{
              item.platform_name ? item.platform_name : '&nbsp;'
            }}</a>
          </div>
          <p cclass="van-ellipsis">
            {{ item.name }}
          </p>
        </div>
      </div>
      <div v-show="usrIndex != 0">
        <div
          class="game-item"
          v-for="(item, index) in gameData.filter(
            x =>
              x.platform_name.toLowerCase().indexOf(key) != -1 ||
              x.name.toLowerCase().indexOf(key) != -1
          )"
          :key="index"
          @click="toGame(item)"
        >
          <img :src="item.mobile_img" />
          <div class="name">
            <a class="van-ellipsis">{{
              item.platform_name ? item.platform_name : '&nbsp;'
            }}</a>
          </div>
          <p class="van-ellipsis">
            {{ item.name }}
          </p>
        </div>
      </div>
    </div>
    <div class="type-show-info">
      <van-popup
        v-model="showtype"
        :style="{ height: '80vh%', width: '90vw',background: '#1f253f' }"
        round
      >
        <div v-html="showtypeinfo" />
        <div style="margin: 16px">
          <van-button round block style="border: 1px solid red !important;background: #1f253f;color: red;"
            @click="toTmpGame()" >下一页 <van-icon name="arrow" /></van-button
          >
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GameBoxView',
  inject: ['app'],
  computed: {
    safeWapConfig () {
      return this.app.wapConfig || {}
    }
  },
  data () {
    return {
      tabs: [],
      usrIndex: 0,
      type: null,
      hotGame: [],
      gameData: [],
      key: null,
      showtype: false,
      showtypeinfo: null,
      tmpgameitem:null
    }
  },
  mounted () {
    this.GetGameTabs()
    this.getIndexData()
  },
  methods: {
    async GetGameTabs () {
      await this.$http({
        method: 'get',
        url: 'gameType'
      }).then(data => {
        this.tabs = data.data
        this.tabs.unshift({
          name: this.$t('home.recommended'),
          id: '-1',
          game_img: this.safeWapConfig.recommend_img //require('@/assets/images/type/b5.webp')
        })
      })
    },
    tabClick (item, index) {
      this.type = item
      this.usrIndex = index
      if (this.usrIndex != 0) this.getgamebytab(item)
    },
    async getgamebytab (item) {
      this.gameData = []
      await this.$http({
        method: 'post',
        url: 'categoryEntry',
        data: { category_id: item.id }
      }).then(data => {
        this.gameData = data.data
      })
    },
    async getIndexData () {
      await this.$http({
        method: 'post',
        url: 'indexhot'
      }).then(data => {
        this.hotGame = data.data.games
        //data.data.games.forEach(item => {
        //  this.hotGame = this.hotGame.concat(item)
        //})
      })
    },
    toGame (item) {
      if (
        this.usrIndex != 0 &&
        this.tabs[this.usrIndex] &&
        this.tabs[this.usrIndex].alert_info
      ) {
        this.showtypeinfo = this.tabs[this.usrIndex].alert_info
        this.showtype = true
        this.tmpgameitem = item
      } else {
        this.$router.push({ name: 'game',query:{gamename:item.name,name:item.platform_name, type:item.game_code, code:item.code,supplier:item.supplier} });
      }
    },
    toTmpGame() {
      const item = this.tmpgameitem
       this.$router.push({ name: 'game',query:{gamename:item.name,name:item.platform_name, type:item.game_code, code:item.code,supplier:item.supplier} });
    }
  }
}
</script>

<style lang="scss">
.home-game-box {
  width: 96%;
  margin: 0 auto;
  .type-box {
    width: 1rem;
    float: left;
    margin-left: 0.25rem;
    ul {
      width: 100%;
      li {
        width: 100%;
        color: #fff;
        margin-bottom: 0.3rem;
        .icon {
          width: 1.1rem;
          height: 1.1rem;
          margin: 0 auto 0.1rem;
          border-radius: 50%;
          position: relative;
          img {
            width: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .selected {
          border: 2px solid #d69346 !important;
          // background-color: #99660b !important;
          background: linear-gradient(90deg, #e3aa34, #ffffe0) !important;
          width: 1.1rem;
          height: 1.1rem;
          margin: 0 auto 0.1rem;
          border-radius: 50%;
          position: relative;
          img {
            width: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        p {
          line-height: 1.4;
          font-size: 0.35rem;
        }
      }
    }
  }
  .game-box {
    width: calc(100% - 2rem);
    float: right;
    .game-item {
      margin: 0 10px 40px 0;
      float: left;
      width: calc((100% - 35px) / 3);
      color: #fff;
      position: relative;
      height: 3rem;
      img {
        width: 100%;
        height: 3rem;
        object-fit: contain;
        border-radius: 10px;
      }
      .name {
        position: absolute;
        left: 0;
        bottom: 0.15rem;
        width: 100%;
        text-align: center;
        overflow: hidden;
        p {
          line-height: 0.8;
          padding: 0.05rem 0.05rem 0 0.05rem;
        }
        a {
          font-size: 0.25rem;
          color: #fff;
        }
      }
    }
    .game-box-search {
      padding-bottom: 10px;
      .van-search {
        width: calc(100% - 16px) !important;
        margin: 0px !important;
        padding: 0px !important;
        .van-search__content {
          border-radius: 10px;
          background-color: transparent !important;
          border: 1px solid #fff;
          .van-field__control {
            color: #fff !important;
          }
        }
      }
    }
  }
}
</style>
